"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("@brandfolder/types");exports.isVideoPreviewType=r=>[e.ContentPreviewType.VideoMux,e.ContentPreviewType.VideoOther,e.ContentPreviewType.VideoProcessing].includes(r);
//# sourceMappingURL=preview-type.js.map
